// extracted by mini-css-extract-plugin
export var modal = "_tl-0";
export var table = "_tl-1";